import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROUTE_SEO = {
  "/": {
    title: "THE WOODLAND ERP — Architecture, Interiors & Construction",
    description:
      "An enterprise operating system for architects, interior designers, and construction teams — from lead to handover, in one calm workspace.",
    canonical: "https://thewoodlanderp.in/",
    robots: "index, follow",
    ogType: "website",
  },
  "/login": {
    title: "Sign In | THE WOODLAND ERP",
    description:
      "Sign in to THE WOODLAND ERP — Enterprise operating system for architecture, interior design, and construction management.",
    canonical: "https://thewoodlanderp.in/login",
    robots: "index, follow",
    ogType: "website",
  },
  "/forgot-password": {
    title: "Forgot Password | THE WOODLAND ERP",
    description: "Reset your password for THE WOODLAND ERP.",
    canonical: "https://thewoodlanderp.in/forgot-password",
    robots: "noindex, nofollow",
  },
  "/reset-password": {
    title: "Reset Password | THE WOODLAND ERP",
    description: "Set a new password for THE WOODLAND ERP.",
    canonical: "https://thewoodlanderp.in/reset-password",
    robots: "noindex, nofollow",
  },
};

function updateMetaTag(nameOrProperty, value, isProperty = false) {
  if (!value) return;
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${nameOrProperty}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, nameOrProperty);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function updateCanonical(url) {
  if (!url) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export default function SEOHead() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const config = ROUTE_SEO[path] || {
      title: "THE WOODLAND ERP",
      robots: "noindex, nofollow",
      canonical: `https://thewoodlanderp.in${location.pathname}`,
    };

    document.title = config.title;

    if (config.description) {
      updateMetaTag("description", config.description);
      updateMetaTag("og:description", config.description, true);
      updateMetaTag("twitter:description", config.description);
    }

    updateMetaTag("robots", config.robots);
    updateCanonical(config.canonical);

    // Open Graph
    updateMetaTag("og:title", config.title, true);
    updateMetaTag("og:url", config.canonical, true);
    updateMetaTag("og:type", config.ogType || "website", true);

    // Twitter Card
    updateMetaTag("twitter:card", "summary_large_image");
    updateMetaTag("twitter:title", config.title);
  }, [location]);

  return null;
}
